import { render } from "./CandidateProfile.vue?vue&type=template&id=35de616e&scoped=true"
import script from "./CandidateProfile.vue?vue&type=script&lang=js"
export * from "./CandidateProfile.vue?vue&type=script&lang=js"

import "./CandidateProfile.vue?vue&type=style&index=0&id=35de616e&scoped=true&lang=scss"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35de616e"]])

export default __exports__